export type FormStatusMessage = {
    meassageStatus: MessageStatus;
    formId: string;
    notificationNumber: string;
};

export enum MessageStatus {
    ABORT = 'abort',
    SAVE = 'save',
    HANDOVER = 'handover',
    SUBMIT = 'submit',
}
